export default __webpack_public_path__ + "static/media/glisser.2658cbad.svg";